import * as dayjs from 'dayjs';

//This uses dayjs to find the difference between 2 dates, in days, months or years.
//It returns a number. Integer for exact eg 1 day, decimal for inexact eg 1.25 months.
export function DateDiffEvaluator(
  issueDate: string,
  redemptionDate: string,
  period: 'day' | 'week' | 'month' | 'year'
): number {
  return dayjs(redemptionDate).diff(dayjs(issueDate), period, true);
}
